module.exports = __webpack_public_path__ + "static/media/walk.300f31da.svg";